var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 878",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.96,
    height: 38.607,
    viewBox: "0 0 38.96 38.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M36.945 42.366h-5.357V33.12a1.745 1.745 0 0 0-.4-1.11l-.004-.01a2.154 2.154 0 0 0-.1-.112l-.015-.016-.046-.047L18.2 19.014a1.313 1.313 0 0 0-.112-.1l-.037-.03a1.74 1.74 0 0 0-.086-.064l-.044-.03a1.808 1.808 0 0 0-.094-.057l-.039-.023q-.064-.034-.13-.062l-.055-.022-.088-.032-.062-.019c-.034-.01-.068-.018-.1-.026l-.046-.011c-.049-.01-.1-.017-.149-.023h-.046c-.041 0-.083-.006-.124-.006H1.755A1.755 1.755 0 0 0 0 20.255v35.1a1.755 1.755 0 0 0 1.755 1.755h28.078a1.755 1.755 0 0 0 1.755-1.755v-9.479h5.357s2.016.155 2.016-1.755-2.016-1.755-2.016-1.755zM18.719 24.491l6.881 6.878h-6.881zM28.078 53.6H3.51V22.01h11.7v11.114a1.755 1.755 0 0 0 1.755 1.755h11.113v7.488h-7.6a1.755 1.755 0 1 0 0 3.51h7.6z",
    transform: "translate(0 -18.5)",
    style: {
      fill: "#748d6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 436",
    d: "m1795.207 406.076-4.353 4.353 4.353 4.353",
    transform: "translate(-1774.137 -385.165)",
    style: {
      fill: "none",
      stroke: "#748d6f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImport);
export default __webpack_public_path__ + "static/media/icon-import.7dcad0a0.svg";
export { ForwardRef as ReactComponent };